import { ConnectionAccountScope } from '../types';

export type ConnectionProductsLabel =
  | 'Organization'
  | 'Payroll'
  | 'Deductions'
  | 'Documents';
const labelsMap = new Map<ConnectionProductsLabel, ConnectionAccountScope[]>([
  [
    'Organization',
    [
      'employer:company',
      'employer:directory',
      'employer:employment',
      'employer:individual',
      'employer:ssn',
    ],
  ],
  ['Payroll', ['employer:payment', 'employer:pay_statement']],
  ['Deductions', ['employer:deduction', 'employer:benefits']],
  ['Documents', ['employer:documents']],
]);

export const getConnectionProductsLabels = ({
  scopes,
}: {
  scopes: ConnectionAccountScope[];
}) => {
  /** Cases
   * Organization Label scopes: ['employer:company' or 'employer:directory' or 'employer:employment' or 'employer:individual' or 'employer:ssn']
   * Payroll Label scopes: ['employer:payment' or 'employer:pay_statement']
   * Deductions Label scopes: ['employer:deduction' or 'employer:benefits']
   * Documents Label scopes: ['employer:documents']
   */
  const labels = new Set<ConnectionProductsLabel>();
  scopes.forEach((scope) => {
    labelsMap.forEach((scopes, label) => {
      if (scopes.includes(scope)) {
        labels.add(label);
      }
    });
  });

  return Array.from(labels);
};
